import { EVENT_REPORT } from 'queries/eventSyncs';
import { EVENT_AUDIT } from 'queries/audit';
import { makeApolloClient, logError } from '../util';

export const FETCH_EVENT_SYNCS = 'FETCH_EVENT_SYNCS';
export const FETCH_EVENT_REPORT = 'FETCH_EVENT_REPORT';
export const CLEAR_EVENT_SYNCS = 'CLEAR_EVENT_SYNCS';

const fetchEventSyncs = (eventSyncs, from = '') => ({
	type: FETCH_EVENT_SYNCS,
	from,
	eventSyncs,
});

const fetchEventReport = (report, from = '') => ({
	type: FETCH_EVENT_REPORT,
	from,
	report,
});

export const clearEventSyncs = () => ({
	type: CLEAR_EVENT_SYNCS,
});

export const thunkFetchEventSyncs = (gqlParams, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { searchAuditHistory } = await client.request(EVENT_AUDIT, gqlParams);
		dispatch(fetchEventSyncs(searchAuditHistory, from));
		return searchAuditHistory.nodes;
	} catch (error) {
		logError(error, 'syncs.actions.thunkFetchEventSyncs');
	}
};

export const thunkFetchEventReport = (id, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { attendance } = await client.request(EVENT_REPORT, {
			event_id: id,
		});
		dispatch(fetchEventReport(attendance, from));
	} catch (error) {
		logError(error, 'syncs.actions.fetchEventReport');
	}
};
